module.exports = __webpack_public_path__ + "img/first_bg02.9af23b7d.png";